// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderUploadErrorsModalStyles } from "@insite/content-library/Components/OrderUploadErrorsModal";
import { xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

orderUploadErrorsModalStyles.descriptionText = {
    css: css`
        margin-bottom: 15px;
    `,
};

orderUploadErrorsModalStyles.buttonsWrapper = {
    css: css`
        margin-top: 30px;
        display: flex;
        flex-wrap: wrap;
    `,
};

orderUploadErrorsModalStyles.cancelUploadButton = {
    variant: "secondary",
    css: css`
        order: 1;
        margin-left: 10px;
        ${xScreen("lte", "xs")} {
            width: 100%;
            margin-left: 0;
        }
    `,
};

orderUploadErrorsModalStyles.continueUploadButton = {
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
            margin-bottom: 10px;
        }
    `,
};
